import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * OAuth callback component for Microsoft Calendar integration.
 *
 * This component handles the redirect from Microsoft OAuth:
 * 1. Parses the authorization code and state from URL parameters
 * 2. Sends a postMessage to the parent (opener) window
 * 3. Closes itself
 */
@Component({
  selector: 'app-microsoft-oauth-callback',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="oauth-callback">
      <p>Completing authentication...</p>
    </div>
  `,
  styles: [`
    .oauth-callback {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      font-family: sans-serif;
    }
  `]
})
export class MicrosoftOAuthCallbackComponent implements OnInit {

  ngOnInit(): void {
    this.handleCallback();
  }

  private handleCallback(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const receivedState = urlParams.get('state');
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    if (error) {
      console.error('Microsoft OAuth error:', error, errorDescription);
      // Still try to notify parent about the error
      if (window.opener) {
        window.opener.postMessage({ error, errorDescription }, window.location.origin);
      }
      window.close();
      return;
    }

    if (code && receivedState) {
      // Send the code and state back to the parent window
      if (window.opener) {
        window.opener.postMessage({ code, receivedState }, window.location.origin);
        // Close the popup after sending the message
        window.close();
      } else {
        // If no opener (e.g., user navigated directly), redirect to features page
        console.warn('No opener window found. Redirecting to features page.');
        window.location.href = '/features';
      }
    } else {
      console.error('Missing code or state in OAuth callback');
      window.close();
    }
  }
}
